import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=6e7b7380&"
import script from "./EditorWrapper.vue?vue&type=script&lang=js&"
export * from "./EditorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports